import React from 'react';
import { Provider } from 'react-redux';
import { ActionCableProvider } from 'react-actioncable-provider';
import { createStore } from 'redux';
import { Elements } from '@stripe/react-stripe-js';
import AppWrapper from './AppWrapper';
import ActionCableListener from './ActionCableListener';
import reducer from '../reducers';

const mountNode = document.getElementById('data-node');
const stripePublicKey = mountNode.getAttribute('data-stripe_public_key');
const stripeConnectedAccount = mountNode.getAttribute('data-stripe_connected_account');

const shouldLoadStripe = mountNode.getAttribute('data-should_load_stripe') === 'true';
const stripe = shouldLoadStripe ? (new Stripe(stripePublicKey, { stripeAccount: stripeConnectedAccount })) : null;

const App = () => {
  const store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  );

  const appId = mountNode.getAttribute('data-compiled_app_id');
  const accessKey = mountNode.getAttribute('data-access_key');

  const sessionId = mountNode.getAttribute('data-app_session_id');
  const sessionKey = mountNode.getAttribute('data-session_key');

  const socketUrl = mountNode.getAttribute('data-socket_url');

  return (
    <Provider store={store}>
      <ActionCableProvider url={socketUrl}>
        <ActionCableListener />
        <Elements stripe={stripe}>
          <AppWrapper
            appId={appId}
            accessKey={accessKey}
            sessionId={sessionId}
            sessionKey={sessionKey}
          />
        </Elements>
      </ActionCableProvider>
    </Provider>
  );
};

export default App;
